<template>
    <div class="row">
        <div class="col-6 mx-auto">
            <bootstrap-box class="newsroom-item">
                <template v-slot:header>
                    <h3 class="title news-item-title">{{title}}</h3>

                    <template v-if="canWrite">
                        <router-link :to="{name: 'newsroom-edit', params: { id }}"
                                     class="mdb-icon-btn edit pull-right mt-1">
                            <i class="fa fa-pencil"/>
                        </router-link>
                    </template>
                </template>
                <template v-slot:body>
                    <div class="row">
                        <div class="col">
                            <p class="newsroom-item-content">
                                {{content}}
                            </p>
                        </div>
                    </div>
                </template>
                <template v-slot:footer>
                    <div class="row">
                        <div class="col-12">
                            <h5 class="pull-right mt-2">
                                {{date | formatDate}}
                            </h5>
                        </div>
                    </div>
                </template>
            </bootstrap-box>
        </div>
    </div>
</template>

<script>
    import permissionsMixin from "../Mixins/permissions";
    import dateFormattingMixin from "../Mixins/date-formatting";
    
    import BootstrapBox from "../../../Components/Util/BootstrapBox.vue";
    
    export default {
        components: {
            BootstrapBox
        },
        mixins: [dateFormattingMixin, permissionsMixin],
        props: {
            id: String,
            
            date: String,
            content: String,
            title: String
        }
    }
</script>